const { getCookie } = require('@/util/util.js')

export default function authHeader () {
    const token = getCookie('token')
    return token
}
